/*
 * @Author: 张玉婷
 * @Date: 2022-03-31 17:08:29
 * @LastEditTime: 2022-04-01 18:55:01
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\cesium\windyUtils\Particle.js
 */
/* eslint-disable */
const Particle = function () {
  this.x = null;
  this.dx = null;
  this.dx = null;
  this.y = null;
  this.age = null;
  this.birthAge = null;
  this.path = null;
};

export default Particle;
